import { Link } from "react-router-dom";
import Table, { ColumnDefinitionType } from '../../../../components/Table'
import { useEmpresaGestora } from "../../../../hooks/useEmpresaGestora";
import { EmpresaGestora } from "../../../../types/EmpresaGestora";
import { Loading } from "../../../../components/Loading";
import { useEffect, useMemo, useState } from "react";
import Confirm from "../../../../components/Confirm";
import { toast } from "react-toastify";
import { useUserLogin } from "../../../../hooks/useUserLogin";


const TableEmpresaGestora = () => {
    const { empresaGestoraList, loading, empresaGestoraInitial, eliminarEmpresaGestora, activarEmpresaGestora, buscarEmpresasGestoras, filtro } = useEmpresaGestora();
    const { isSistemaTipoUsuario } = useUserLogin();

    const [showModal, setShowModal] = useState<boolean>(false);
    const [data, setData] = useState<EmpresaGestora>(empresaGestoraInitial);
    const toggle = () => setShowModal(!showModal);

    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        setPage(1);
    }, [empresaGestoraList]);

    const eliminar = () => {
        eliminarEmpresaGestora(data.id as unknown as string)
            .then(() => { buscarEmpresasGestoras(filtro) })
            .catch((err: any) => {
                if (err?.response?.status === 403) {
                    toast.error("No tiene permisos para eliminar la Empresa Gestora");
                } else {
                    toast.error(err?.response?.data?.message || "Hubo un error al eliminar la Empresa Gestora");
                }
            })
        toggle();
    }

    const activar = (empresaGestora: EmpresaGestora) => {
        activarEmpresaGestora(empresaGestora.id as unknown as string)
            .then(() => { buscarEmpresasGestoras(filtro) })
            .catch((err: any) => {
                if (err?.response?.status === 403) {
                    toast.error("No tiene permisos para reactivar la Empresa Gestora");
                } else {
                    toast.error(err?.response?.data?.message || "Hubo un error al reactivar la Empresa Gestora");
                }
            })
    }

    const totalPages = Math.max(1, Math.ceil((empresaGestoraList?.length || 0) / pageSize));
    const dataPaginada = useMemo(() => {
        const start = (page - 1) * pageSize;
        return (empresaGestoraList || []).slice(start, start + pageSize);
    }, [empresaGestoraList, page, pageSize]);

    const columns: ColumnDefinitionType<EmpresaGestora, keyof EmpresaGestora>[] = [
        {
            key: 'tipoDocumento',
            header: 'Tipo Identificación',
        },
        {
            key: 'nroIdentificacion',
            header: 'Número Identificación',
        },
        {
            key: 'nombreEmpresa',
            header: 'Razón Social',
        },
        {
            key: 'activo',
            header: 'Estado',
            cell: (data: EmpresaGestora) => <>{data.activo ? 'ACTIVA' : 'INACTIVA'}</>
        },
        {
            key: 'id',
            header: 'Acciones',
            cell: (data: EmpresaGestora) =>
                <>
                    <Link to={`/empresasGestoras/editar/${data.id}?action=view`} title="Visualizar">
                        <i className="fa fa-eye text-secondary me-2" aria-hidden="true"></i>
                    </Link>
                    <Link to={`/empresasGestoras/editar/${data.id}`} title="Editar" >
                        <i className="fa fa-pencil text-custom me-2" aria-hidden="true"></i>
                    </Link>
                    {data.activo
                        ? <Link to="#" title="eliminar"
                            onClick={(e) => {
                                e.stopPropagation();
                                setData(data);
                                setShowModal(true)

                            }}
                        >
                            <i className="fa fa-trash-o text-danger" aria-hidden="true"></i>
                        </Link>
                        : <Link to="#" title="reactivar"
                            onClick={(e) => {
                                e.stopPropagation();
                                activar(data);
                            }}
                        >
                            <i className="fa fa-undo text-success" aria-hidden="true"></i>
                        </Link>
                    }

                </>
        },
    ]

    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        {<p>Está seguro que desea eliminar la Empresa Gestora {data.nombreEmpresa}?</p>}
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h4 className="m-t-0 header-title">
                                        <i className="fa fa-list-ul" aria-hidden="true" style={{ marginRight: "5px" }}></i>

                                        Listado de Empresas Gestoras
                                        {isSistemaTipoUsuario() &&
                                            <Link to={`/empresasGestoras/nuevo`} title="Nuevo" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}>
                                                <i className="fa fa-plus margin-right-10"></i> Nuevo
                                            </Link>
                                        }

                                    </h4>

                                </div>

                                <div className="table-responsive">
                                    <br />

                                    {loading ? <Loading /> : <Table data={dataPaginada} columns={columns}></Table>}

                                    <div className="row mx-0 mt-2 align-items-center">
                                        <div className="col-auto">
                                            <label className="me-2">Mostrar</label>
                                            <select
                                                className="form-control select-list d-inline-block"
                                                style={{ width: 'auto' }}
                                                value={pageSize}
                                                onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <label className="ms-2">registros por página</label>
                                        </div>
                                        <div className="col text-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm mx-1"
                                                disabled={page <= 1}
                                                onClick={() => setPage(p => Math.max(1, p - 1))}
                                            >
                                                <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                            </button>
                                            <span>Página {page} de {totalPages}</span>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm mx-1"
                                                disabled={page >= totalPages}
                                                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                            >
                                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    )
}

export default TableEmpresaGestora;
